import * as Styled from './RadioTab.styled';
import React from 'react';
import RadioTabOption from './RadioTabOption';
import { RadioTabProps } from './RadioTab.types';

export const RadioTab = ({
  name,
  disabled = false,
  required = false,
  hasError = false,
  options,
  selectedOption,
  onChange,
}: RadioTabProps) => {
  const totalOfRadioTabOptions = options.length;
  const hasSelectedValue = selectedOption && selectedOption.value;
  const selectedIndex =
    options &&
    hasSelectedValue &&
    options.findIndex((option) => option.value === selectedOption.value);

  return (
    <Styled.RadioTab hasError={hasError} disabled={disabled}>
      {totalOfRadioTabOptions > 0 &&
        options.map((option) => {
          const isChecked =
            !disabled &&
            !hasError &&
            selectedOption &&
            selectedOption.value === option.value;

          return (
            <RadioTabOption
              name={name}
              key={option.value}
              checked={isChecked}
              value={option.value}
              text={option.displayText}
              onChange={onChange}
              required={required}
              hasError={hasError}
              disabled={disabled}
            />
          );
        })}
      {!hasError &&
        totalOfRadioTabOptions > 0 &&
        typeof selectedIndex === 'number' && (
          <Styled.RadioTabChecked
            disabled={disabled}
            index={selectedIndex}
            total={totalOfRadioTabOptions}
          />
        )}
    </Styled.RadioTab>
  );
};

export default RadioTab;
